import axios from "axios";

export const postBotsUpdate = async (
	dev,
	selectedOption,
	payload,
	callbacks
) => {
	const { setLoading, resetForm, enqueueSnackbar } = callbacks;

	const getEndpoint = () => {
		switch (selectedOption) {
			case "leaderboard":
				return `/api/dev/${dev}/leaderboard/bots`;
			case "league":
				return `/api/dev/${dev}/league/bots`;
			case "tournament":
				return `/api/dev/${dev}/tournament/bots`;
			case "leagueRank":
				return `/api/dev/${dev}/league/rank`;
			case "luckyDice":
				return `/api/dev/${dev}/luckydice`;
			case "leagueReceiptExpire":
				return `/api/dev/${dev}/league/receipt-expire`;
			case "leagueChange":
				return `/api/dev/${dev}/league/change`;
			default:
				return "";
		}
	};

	setLoading(true);
	const endpoint = getEndpoint();

	try {
		const response =
			selectedOption === "leagueReceiptExpire"
				? await axios.get(endpoint, { params: payload })
				: await axios.post(endpoint, payload);
		setLoading(false);
		resetForm();
		enqueueSnackbar(
			`${
				selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)
			} Updated Successfully!`,
			{
				variant: "success",
			}
		);
		return response.data;
	} catch (err) {
		setLoading(false);
		console.error(`Error updating ${selectedOption}:`, err);
		enqueueSnackbar("Error: " + (err.response?.data?.message || err.message), {
			variant: "error",
		});
		throw err;
	}
};
